module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 30.ed54f3f9.png";